import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'success' | 'warning' | 'error';
type Size = 'sm' | 'md' | 'lg';

interface GabButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  loading?: boolean;
}

export function GabButton({
  variant = 'primary', size = 'md', leftIcon, rightIcon, loading, children, className = '', disabled, ...rest
}: GabButtonProps) {
  const cls = [
    'btn',
    `btn-${variant}`,
    size !== 'md' ? `btn-${size}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={cls} disabled={disabled || loading} {...rest}>
      {loading && <span className="spinner-sm" style={{ width: 14, height: 14, borderWidth: 2 }} />}
      {!loading && leftIcon}
      {children}
      {rightIcon}
    </button>
  );
}
